/* Drag-to-compare, for every [data-mcp-cmp] on the page.
 *
 * Lifted from setCompare() / wireCompare() in sections/product-configurator-lab.liquid.
 * The ONE change is that the original reaches for its parts by id — $('mcp-cmp'),
 * $('mcp-cmp-top'), $('mcp-cmp-bar') — which allows exactly one slider per page.
 * Here each stage keeps its own percentage and finds its own parts inside itself,
 * so three of them can sit on one page without touching each other.
 *
 * The product page's quality modal is deliberately NOT one of these: it has no
 * data-mcp-cmp attribute, so it stays with its own wiring.
 *
 * Everything else is the proven behaviour, unchanged: reveal by clipping rather
 * than resizing, the inner image pinned to the container's pixel width so the two
 * halves stay in register, pointer capture so a drag that leaves the box keeps
 * working, keyboard control on a focusable role="slider", and a re-measure on
 * resize because the clipped image is sized in pixels. touch-action: pan-y is set
 * in mcp-made.css — it hands the horizontal axis to the control and leaves the
 * vertical one to the page, so a sideways drag moves the handle and a flick down
 * still scrolls.
 *
 * Loaded with `defer` from each section that uses it, so this may run twice on a
 * page that has two such sections; the guards below make that a no-op.
 */
(function () {
  if (window.__mcpCmpWired) return;
  window.__mcpCmpWired = true;

  function wire(c) {
    if (!c || c.dataset.wired) return;
    c.dataset.wired = '1';

    var top = c.querySelector('[data-mcp-cmp-top]');
    var bar = c.querySelector('[data-mcp-cmp-bar]');
    if (!top || !bar) return;

    var pct = 50;

    /* Reveal by CLIPPING the top layer, never by resizing it: the inner image
       keeps the container's own width so the two halves stay in register as the
       handle moves. Resizing the wrapper would squash one against the other and
       the comparison would be worthless. */
    function set(v) {
      pct = Math.max(0, Math.min(100, v));
      top.style.width = pct + '%';
      bar.style.left = pct + '%';
      var inner = top.querySelector('img');
      if (inner) inner.style.width = c.clientWidth + 'px';
      c.setAttribute('aria-valuenow', Math.round(pct));
      c.setAttribute('aria-valuetext', Math.round(pct) + ' percent preview');
    }

    var dragging = false;
    function at(clientX) {
      var r = c.getBoundingClientRect();
      if (!r.width) return;
      set(((clientX - r.left) / r.width) * 100);
    }

    c.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (c.setPointerCapture) { try { c.setPointerCapture(e.pointerId); } catch (err) {} }
      at(e.clientX);
    });
    c.addEventListener('pointermove', function (e) { if (dragging) at(e.clientX); });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      c.addEventListener(ev, function () { dragging = false; });
    });

    c.addEventListener('keydown', function (e) {
      var step = e.shiftKey ? 10 : 4;
      if (e.key === 'ArrowLeft') { e.preventDefault(); set(pct - step); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); set(pct + step); }
      else if (e.key === 'Home') { e.preventDefault(); set(0); }
      else if (e.key === 'End') { e.preventDefault(); set(100); }
    });

    window.addEventListener('resize', function () { set(pct); });

    /* The images are lazy, so the first measurement can happen before the top
       one has a box to be pinned into. Re-run once it lands. */
    var img = top.querySelector('img');
    if (img && !img.complete) img.addEventListener('load', function () { set(pct); });

    set(50);
  }

  function wireAll() {
    var list = document.querySelectorAll('[data-mcp-cmp]');
    for (var i = 0; i < list.length; i++) wire(list[i]);
  }

  wireAll();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wireAll);
  }
  /* The theme editor re-renders a section without reloading the page. */
  document.addEventListener('shopify:section:load', wireAll);
})();
